import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import { Breakpoints } from "constants/Breakpoints";

import { QuicksandMedium } from "components/Text";
import { Text, FontWeight } from 'components/Text';
import { Col } from 'components/Grid';
import AIOLogo from "components/Icon/png/AIO-logo.png";
import DentalisLogo from "components/Icon/png/Dentalis-logo.png";

export const Container = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
  padding: 20px 20px 50px 20px;
  display: block;
//  flex-direction: column;
  ::-webkit-scrollbar {
    background: ${Colors.WHITE};
    width: 8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${Colors.WHITE};

  margin-bottom: 24px;
  margin-top: 15px;
  background: ${Colors.WHITE};
  border-radius: 8px;
  border: 1px 1px 1px 1px solid;
  box-sizing: border-box;
  //border: 1px solid ${Colors.ORANGE[0]};
  //  box-shadow: 0px 17px 17px 6px ${Colors.GRAY[4]};
  box-shadow: 0px 15px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 10px;
`;

export const Fieldset = styled(Col)`
  padding: 0px 10px 20px 0px;
`;

export const AdvisoryText = styled.label`
  ${QuicksandMedium}
  font-style: normal;
  font-size: 12px;
  padding-left: 10px;
`;
export const FieldLabel = styled.label`
  ${QuicksandMedium}
  font-style: normal;
  font-size: 14px;
  line-height: 150%;
  padding-left: 15px;
`;

export const Heading = styled(Text)`
  color: ${Colors.SECONDARY};
  font-size: 24px;
  padding-left: 10px;
  font-weight: ${FontWeight.Bold};
  
  @media (max-width: ${Breakpoints.xl}) {
    font-size: 24px;
  }
  @media (max-width: ${Breakpoints.md}) {
    font-size: 20px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    font-size: 18px;
  }
`;

export const Title = styled(Text)`
  margin-top: 0px;
  font-size: 30px;
  font-weight: ${FontWeight.Bold};
  color: ${Colors.TITLE};
  @media (max-width: ${Breakpoints.xl}) {
    font-size: 30px;
  }
  @media (max-width: ${Breakpoints.md}) {
    font-size: 28px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    font-size: 22px;
  }
`;

export const Head = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  @media (max-width: ${Breakpoints.xs}) {
   flex-direction: column;
   align-items: flex-start;
  }
`;

export const Logo = styled.div`
  width: 280px;
  height: 70px;
  ${({user})=> user === process.env.REACT_APP_USER_AIO_DENTALIS 
    ? `background: url(${DentalisLogo}) no-repeat center;`
    :` background: url(${AIOLogo}) no-repeat center; `}
  /* background: url(${AIOLogo}) no-repeat center; */
  background-size: 100% 100%;
  display:block ;

  @media (max-width: ${Breakpoints.xl}) {
    width: 280px;
    height: 70px;
  }
  @media (max-width: ${Breakpoints.md}) {
    width: 200px;
    height: 70px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    width: 180px;
    height: 50px;
  }
`;

export const Subtitle2 = styled(Text)`
  margin-top: 15px;
  font-size: 16px;
  font-weight: ${FontWeight.Medium};
  color: ${Colors.SUBTITLE};
  display: block;
  @media (max-width: ${Breakpoints.xl}) {
    font-size: 16px;
  }
  @media (max-width: ${Breakpoints.md}) {
    font-size: 14px;
  }
  @media (max-width: ${Breakpoints.xs}) {
    font-size: 11px;
    margin-top: 5px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  padding: 0px;
`;

export const BackToList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

export const CalendarContainer = styled.div`
  z-index: 1;
  top: 60px;
  right: 24px;
  position: absolute;
  padding-bottom: 50px;
`;

export const Line = styled.div`
    width: 100%;
    height: 1px;
    margin-top: 20px;
    background-color: ${Colors.GRAY[3]};
`;